import { Pipe, PipeTransform } from '@angular/core';
import { UserService } from '@features/user/services/user.service';

@Pipe({
  name: 'localeLabel',
  pure: false,
})
export class LocaleLabelPipe implements PipeTransform {
  constructor(private userService: UserService) {}

  public transform(value: Record<string, string> | string, fallbackLocale: string = 'en'): string {
    if (!value) {
      return '-';
    }

    if (typeof value === 'string') {
      return value;
    }

    const localeCode = this.userService.getCurrentUser()?.locale?.code;

    if (localeCode && value[localeCode]) {
      return value[localeCode];
    }

    if (fallbackLocale && value[fallbackLocale]) {
      return value[fallbackLocale];
    }

    const firstValue = Object.values(value).find(label => !!label);
    return firstValue ?? '-';
  }
}

